import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ClipboardList,
  History,
  Upload,
  KeyRound,
} from "lucide-react";
import AdminLayout from "./AdminLayout";

const options = [
  {
    label: "Manage Result",
    desc: "Add / Delete result entries",
    to: "/admin/result",
    icon: ClipboardList,
    color: "#4a7fb5",
  },
  {
    label: "Previous Result",
    desc: "Add / Delete / Publish",
    to: "/admin/previous",
    icon: History,
    color: "#3aa79a",
  },
  {
    label: "Bulk Import",
    desc: "Import verified history (CSV/JSON)",
    to: "/admin/bulk-import",
    icon: Upload,
    color: "#2f5d84",
  },
  {
    label: "Change Password",
    desc: "Update your admin password",
    to: "/admin/password",
    icon: KeyRound,
    color: "#c0873a",
  },
];

const AdminDashboard = () => {
  const navigate = useNavigate();
  return (
    <AdminLayout title="Dashboard">
      <h2 className="text-lg font-bold text-[#1f2a37] mb-4">
        Welcome, Admin
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {options.map((o) => {
          const Icon = o.icon;
          return (
            <button
              key={o.to}
              onClick={() => navigate(o.to)}
              className="flex items-center gap-4 bg-white border border-gray-200 rounded-xl p-4 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
            >
              <span
                className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0"
                style={{ backgroundColor: `${o.color}22` }}
              >
                <Icon className="w-6 h-6" style={{ color: o.color }} />
              </span>
              <span>
                <span className="block font-semibold text-[#1f2a37]">
                  {o.label}
                </span>
                <span className="block text-xs text-gray-500">{o.desc}</span>
              </span>
            </button>
          );
        })}
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
